import React, { useRef, useState, useEffect } from "react";
import exportIcon from '../../../assets/image/document-download.png';

const ExportDropdown = ({ exportReport, filteredReports, formats, periods }) => {
    const dropdownRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [format, setFormat] = useState(formats[0]?.value || "");
    const [period, setPeriod] = useState(periods[0] || "");

    const toggleDropdown = () => setShowDropdown((prev) => !prev);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setShowDropdown(false);
            }
        };
        if (showDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showDropdown]);

    return (
        <>
            {showDropdown && (
                <div
                    onClick={() => setShowDropdown(false)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "transparent",
                        zIndex: 999,
                    }}
                />
            )}

            <div
                ref={dropdownRef}
                style={{ position: "relative", zIndex: showDropdown ? 1000 : 0 }}
            >
                <button
                    className="btn btn-outline-dark d-flex align-items-center gap-2"
                    onClick={toggleDropdown}
                    style={{
                        border: showDropdown
                            ? "1px solid rgba(79, 70, 229, 0.5)"
                            : "1px solid #E4E4E7",
                        backgroundColor: showDropdown
                            ? "#F3F4F6"
                            : "#FFFFFF",
                        color: "#1F1F23",
                        borderRadius: "5px",
                        padding: "6px 14px",
                        fontSize: "12px",
                        fontWeight: "500",
                        boxShadow: showDropdown
                            ? "0px 0px 4px rgba(79, 70, 229, 0.5)"
                            : "0px 1px 2px rgba(16, 24, 40, 0.05)",
                        transition: "box-shadow 0.2s ease-in-out",
                    }}
                >
                  <img className="fs-12"
                                         src={exportIcon}
                                         alt="Export Icon"
                                         width="16"
                                         height="16"
                                       />
                    Export
                </button>

                {showDropdown && (
                    <div
                        className="card shadow-sm position-absolute end-0"
                        style={{
                            width: "220px",
                            zIndex: 1001,
                            background: "#fff",
                            borderRadius: "6px",
                            top: "100%",
                            marginTop: "1px",
                            fontSize:"12px",
                            boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
                        }}
                    >
                        <div className="px-3 py-2 border-bottom">
                            <div
                                className="text-muted fw-semibold mb-1"
                                style={{ fontSize: "12px" }}
                            >
                                Format
                            </div>
                            <div className="btn-group w-100">
                                {formats.map((f) => (
                                    <button
                                        key={f.value}
                                        className={`btn ${format === f.value ? "btn-dark text-white" : "btn-outline-dark"
                                            }`}
                                        onClick={() => setFormat(f.value)}
                                    >
                                        <i className={`bi ${f.icon}`}></i> {f.label}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="px-3 py-2 border-bottom">
                            <div
                                className="text-muted fw-semibold mb-1"
                                style={{ fontSize: "12px" }}
                            >
                                Period
                            </div>
                            {periods.map((p) => (
                                <div
                                    key={p}
                                    className="d-flex justify-content-between align-items-center py-1"
                                    style={{
                                        fontSize: "12px",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setPeriod(p)}
                                >
                                    <span>{p}</span>
                                    <span>{period === p ? "✔" : ""}</span>
                                </div>
                            ))}
                        </div>

                        <div className="d-flex justify-content-end px-3 py-2">
                            <button
                                className="btn btn-dark w-100 fs-12"
                                onClick={() => {
                                    exportReport(filteredReports, format, period);
                                    setShowDropdown(false);
                                }}
                            >
                                Export
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ExportDropdown;
